import type { FunctionComponent } from 'react';
import { useCallback } from 'react';

import { useCoreDispatch } from '../../store/CoreStore';
import { toastActions, ToastsProps } from '../../store/slices/toast/slice';
import { Toast } from '../toast/Toast';

import {
  GameCanceledToastConnected,
  AutoplayNotChangedToastConnected,
  TableCloseNotifyToastConnected,
  SubtitlesClosedToastConnected,
} from './exceptions';

export const ToastConnected: FunctionComponent<ToastsProps> = ({ msg, timeStamp, ...rest }) => {
  const dispatch = useCoreDispatch();

  const closeFn = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [dispatch, timeStamp]);

  switch (msg) {
    // Special cases with controls handling etc
    case 'TOAST_GAME_CANCELLED':
      return <GameCanceledToastConnected msg={msg} timeStamp={timeStamp} {...rest} />;
    case 'AUTOPLAY_CONTINUED_NO_CHANGES':
      return <AutoplayNotChangedToastConnected msg={msg} timeStamp={timeStamp} {...rest} />;
    case 'TABLE_WILL_CLOSE':
      return <TableCloseNotifyToastConnected msg={msg} timeStamp={timeStamp} {...rest} />;
    case 'TOAST_SUBTITLES_OFF':
      return <SubtitlesClosedToastConnected msg={msg} timeStamp={timeStamp} {...rest} />;
    case '':
    case null:
      return null;
    default:
      return <Toast message={msg} onClose={closeFn} {...rest} />;
  }
};
